import type { AppAction, ThunkAction } from '../../types/app.types';

/**
 * Types
 */
type Experiment = {
  name: string;
  // the name of the experiment
  value: string; // the name of the variation
};
export type ABState = Array<Experiment>;
export type SetExperiments = {
  type: 'ab/SET_EXPERIMENTS';
  experiments: Array<Experiment>;
};
export type ABAction = SetExperiments;

/**
 * Actions
 */
export const setExperiments =
  (experiments: Array<Experiment>): ThunkAction<SetExperiments> =>
  (dispatch: any): SetExperiments => {
    return dispatch({
      type: 'ab/SET_EXPERIMENTS',
      experiments,
    });
  };

/**
 * Selectors
 */
export const getExperimentVariation = (state: ABState, experimentName: string): string | null | undefined => {
  const exp = state.find((e) => e.name === experimentName);
  return exp && exp.value;
};
/**
 * Reducer
 */

export default function abReducer(state: ABState = [], action: AppAction): ABState {
  return action.type === 'ab/SET_EXPERIMENTS' ? [...action.experiments] : state;
} // Auto-Refill Turn Off Modal state

export const showTurnOffAutoRefillModal = (state: ABState): boolean =>
  getExperimentVariation(state, 'auto_refill_toggle_modal') === 'variation';
